<mat-drawer #drawer mode="side" disableClose="true" opened="true">
  <div class="items-nav">
    <mat-nav-list *ngFor="let item of navbar">
      <mat-list-item (click)="expandSection(item)" [matTooltip]="item.Tooltip" matTooltipPosition='right'
        *ngIf="item.Separador" class="separador">
        <mat-icon mat-list-icon>{{item.Icon}}</mat-icon>
        <h4 mat-line *ngIf="isExpanded">{{item.Title}}</h4>
      </mat-list-item>
      <!-- <mat-toolbar-row matTooltipPosition='right' *ngIf="item.separador">
        <mat-icon mat-list-icon></mat-icon>
        <h4 mat-line *ngIf="isExpanded">Pedidos Portal MPA</h4>
      </mat-toolbar-row> -->
      <mat-list-item (click)="expandSection(item)" [matTooltip]="item.Tooltip" matTooltipPosition='right'
        *ngIf="item.Route == '' && !item.CustomFunction && !item.Separador">
        <mat-icon mat-list-icon>{{item.Icon}}</mat-icon>
        <h4 mat-line *ngIf="isExpanded">{{item.Title}}</h4>
      </mat-list-item>
      <mat-list-item (click)="newOrder()" [matTooltip]="item.Tooltip" matTooltipPosition='right'
        *ngIf="item.CustomFunction == 'order'">
        <mat-icon mat-list-icon>{{item.Icon}}</mat-icon>
        <h4 mat-line *ngIf="isExpanded">{{item.Title}}</h4>
      </mat-list-item>
      <mat-list-item [matTooltip]="item.Tooltip" matTooltipPosition='right'
        *ngIf="item.Route != '' && !item.CustomFunction && !item.Separador && !item.EndPoint" [routerLink]="item.Route">
        <mat-icon mat-list-icon>{{item.Icon}}</mat-icon>
        <h4 mat-line *ngIf="isExpanded">{{item.Title}}</h4>
      </mat-list-item>
      <mat-list-item [matTooltip]="item.Tooltip" matTooltipPosition='right'
        *ngIf="item.Route != '' && !item.CustomFunction && !item.Separador && item.EndPoint" [routerLink]="item.Route">
        <mat-icon mat-list-icon  [matBadge]="item.Badge" matBadgeColor="success">{{item.Icon}}</mat-icon>
        <h4 mat-line *ngIf="isExpanded">{{item.Title}}</h4>
      </mat-list-item>
      <div class="mpa-submenu-list" *ngIf="item.Expanded">
        <div *ngFor="let element of item.Submenu">
          <mat-list-item [routerLink]="element.Route" [matTooltip]="element.Tooltip" matTooltipPosition='right'
            *ngIf="element.Route != '' && !item.Separador">
            <mat-icon mat-list-icon mat-list-icon-sub>{{element.Icon}}</mat-icon>
            <h5 mat-line *ngIf="isExpanded">{{element.Title}}</h5>
          </mat-list-item>
          <mat-list-item (click)="loadusers()" [matTooltip]="element.Tooltip" matTooltipPosition='right'
            *ngIf="element.CustomFunction == 'loadusers'">
            <mat-icon mat-list-icon>{{element.Icon}}</mat-icon>
            <h4 mat-line *ngIf="isExpanded">{{element.Title}}</h4>
          </mat-list-item>
          <mat-list-item (click)="sendorder()" [matTooltip]="element.Tooltip" matTooltipPosition='right'
            *ngIf="element.CustomFunction == 'sendorder'">
            <mat-icon mat-list-icon>{{element.Icon}}</mat-icon>
            <h4 mat-line *ngIf="isExpanded">{{element.Title}}</h4>
          </mat-list-item>
        </div>
      </div>
    </mat-nav-list>
  </div>
  <div class="button-nav" *ngIf="authService.isAuthenticated()">
    <button mat-mini-fab (click)="isExpanded = !isExpanded" color="warn" style="margin: 10px;">
      <mat-icon aria-label="Menu" *ngIf="!isExpanded">arrow_forward_ios</mat-icon>
      <mat-icon aria-label="Menu" *ngIf="isExpanded">arrow_back_ios</mat-icon>
    </button>
  </div>
</mat-drawer>